import { render, staticRenderFns } from "./NoticeBox.vue?vue&type=template&id=786720cc&"
import script from "./NoticeBox.vue?vue&type=script&lang=ts&"
export * from "./NoticeBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports